<div class="content">
  <div class="content-panel">
    <h2 translate>page.declarations.suivi-declarations.title</h2>
    <form [formGroup]="searchForm" #form="ngForm" (ngSubmit)="search()" novalidate class="ps-2">
      <div class="cols">
        <div class="col">
          <div class="row">
            <!-- Millésime -->
            <div class="col-md-2">
              <div class="mb-3">
                <label class="form-label" translate>page.declarations.suivi-declarations.list.annee</label> :
                <input type="text" lang="en" formControlName="annee" class="form-control" [ngClass]="{'is-invalid': form.submitted && searchForm.get('annee').invalid}" />
              </div>
            </div>

            <!-- Raison sociale -->
            <div class="col-md-2">
              <div class="mb-3">
                <label class="form-label" translate>page.declarations.suivi-declarations.list.raisonSociale</label> :
                <input type="text" lang="en" formControlName="raisonSociale" class="form-control" />
              </div>
            </div>

            <!-- Type déclaration -->
            <div class="col-md-2">
              <div class="mb-3">
                <label class="form-label" for="typeDeclaration" translate>page.declarations.suivi-declarations.list.typeDeclaration</label> :
                <div *ngIf="referentiel?.refMouvements">
                  <app-multiselect id="typeDeclaration" controlName="typeDeclaration" [items]="referentiel.refMouvements"
                                   bindLabel="libelle" maxWidth="initial" class="form-control-multiselect type-input">
                  </app-multiselect>
                </div>
              </div>
            </div>

            <!-- Cahier des charges -->
            <div class="col-md-2">
              <div class="mb-3">
                <label class="form-label" for="cdc" translate>page.declarations.suivi-declarations.list.cdc</label> :
                <div *ngIf="cahiers">
                  <app-multiselect id="cdc" controlName="cdc" [items]="cahiers"
                                   bindLabel="libelle" maxWidth="initial" class="form-control-multiselect type-input">
                  </app-multiselect>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <!-- Date de déclaration début -->
            <div class="col-md-2">
                <label for="debutDate" class="form-label pt-0"
                       translate>page.declarations.suivi-declarations.list.dateEntre</label> :
                <div class="input-group">
                  <input id="debutDate" ngbDatepicker #debutDatepicker="ngbDatepicker"
                         formControlName="debutDate" class="form-control" />
                  <button type="button" (click)="debutDatepicker.toggle()" class="btn btn-secondary">
                    <fa-icon icon="calendar-alt"></fa-icon>
                  </button>
                </div>
            </div>

            <!-- Date de déclaration fin -->
            <div class="col-md-2">
                <label for="finDate" class="form-label pt-0"
                       translate>page.declarations.suivi-declarations.list.et</label> :
                <div class="input-group">
                  <input id="finDate" ngbDatepicker #finDatepicker="ngbDatepicker"
                         formControlName="finDate" class="form-control" />
                  <button type="button" (click)="finDatepicker.toggle()" class="btn btn-secondary">
                    <fa-icon icon="calendar-alt"></fa-icon>
                  </button>
                </div>
            </div>

            <!-- Décision de contrôle -->
            <div class="col-md-2">
              <div class="mb-3">
                <label class="form-label" translate>page.declarations.suivi-declarations.list.decisionControle</label> :
                <select formControlName="non_controlable" class="form-control" [ngClass]="{'is-invalid': form.submitted && searchForm.get('non_controlable').invalid}">
                  <option [ngValue]="null">Tous</option>
                  <option Value="false">A contrôler</option>
                  <option Value="true">Non controlé</option>
                </select>
              </div>
            </div>

            <!-- Suivi -->
            <div class="col-md-2">
              <div class="mb-3">
                <label class="form-label" translate>page.declarations.suivi-declarations.list.suivi</label> :
                <select formControlName="suivi" class="form-control" [ngClass]="{'is-invalid': form.submitted && searchForm.get('suivi').invalid}">
                  <option Value="undefined">Tous</option>
                  <option Value="false">Non lu</option>
                  <option Value="true">Lu</option>
                </select>
              </div>
            </div>

            <!-- Bouton filtrer -->
            <div class="d-flex mb-3">
              <button type="submit" class="btn btn-primary" translate>label.filtrer</button>
            </div>
          </div>
        </div>
      </div>
    </form>

      <table class="table table-striped" aria-label="Liste des historiques de suivi de déclaration" *ngIf="historiques?.length > 0; else aucunHistorique">
          <thead>
          <tr>
              <th scope="col" class="liste-col-header" rowspan="2" translate>page.declarations.suivi-declarations.table.header.numeroDeclaration
              </th>
              <th scope="col" class="liste-col-header" rowspan="2" translate>page.declarations.suivi-declarations.table.header.cvi<br/>
                  page.declarations.suivi-declarations.table.header.raisonSociale</th>
              <th scope="col" class="liste-col-header" rowspan="2" translate>page.declarations.suivi-declarations.table.header.typeDeclaration</th>
              <th scope="col" class="liste-col-header" rowspan="2" translate>page.declarations.suivi-declarations.table.header.date</th>
              <th scope="col" class="liste-col-header" rowspan="2" translate>page.declarations.suivi-declarations.table.header.volumeTotal</th>
              <th scope="col" class="liste-col-header" rowspan="2" translate>page.declarations.suivi-declarations.table.header.produit</th>
              <th scope="col" class="liste-col-header" rowspan="2" translate>page.declarations.suivi-declarations.table.header.annee</th>
              <th scope="col" class="liste-col-header" colspan="2" translate>page.declarations.suivi-declarations.table.header.numero</th>

              <th scope="col" class="liste-col-header" rowspan="2" translate>page.declarations.suivi-declarations.table.header.non_controlable</th>
              <th scope="col" class="liste-col-header" rowspan="2" translate>
                  page.declarations.suivi-declarations.list.suivi
                  <fa-icon icon="envelope-open" (click)="onPasserToutALuOuNonLu(true)"
                           title="{{ 'page.declarations.suivi-declarations.table.header.toutALu' | translate }}"
                           class="pointer icon"></fa-icon>
              </th>
              <th scope="col" rowspan="2"></th>
          </tr>
          <tr>
              <th scope="col" class="liste-col-header" translate>page.declarations.suivi-declarations.table.header.numeroDossier</th>
              <th scope="col" class="liste-col-header" translate>page.declarations.suivi-declarations.table.header.numeroLot</th>
          </tr>
          </thead>

          <tbody>
          <tr *ngFor="let historique of historiques">
              <td>{{ historique.numeroDeclaration}}</td>
              <td>{{ historique.numeroCVI}}
                  <br/>{{ historique.raisonSociale }}</td>
              <td>{{ getTypeMouvement(historique.code) }}</td>
              <td>{{ historique.dateDebut | date:'dd/MM/yyyy' }}</td>
              <td>{{ historique.volume | number:'1.2-2' }}</td>
              <td>{{ historique.produit?.libelle }}</td>
              <td>{{ miseAJourMillesime(historique.annee) }}</td>
              <td>{{ historique.numeroDossier }}</td>
              <td>{{ historique.numeroLot }}</td>
              <td style="text-align:center">
                  <input type="checkbox" [checked]="historique.nonControlable" (change)="changeStatus(historique,$event.target?.checked)">
                  <div >
                      <h4  (click)="onEdit(historique)">
                          <fa-icon icon="info-circle"></fa-icon>
                      </h4>
                  </div>
              </td>
              <td>
          <span class="lue badge" *ngIf="historique.estLu" (click)="onChangerStatutNonLu(historique)"
                translate>page.declarations.suivi-declarations.table.header.lu</span>
                  <span class="non-lue badge" *ngIf="!historique.estLu" (click)="onChangerStatut(historique)"
                        translate>page.declarations.suivi-declarations.table.header.nonLu</span>

              </td>
              <td>
                  <div class="btn-group dropleft  ">
                      <div ngbDropdown placement="bottom-end" container="body">
                          <button class="btn btn-secondary dropdown-toggle btnprimary btn-sm "
                                  id="dropdownConfig" ngbDropdownToggle>
                              <fa-icon icon="cog"></fa-icon>
                          </button>
                          <div ngbDropdownMenu aria-labelledby="dropdownConfig">
                              <button (click)="telechargerDocument(historique)" ngbDropdownItem
                                      class="dropdown-item primary-text">
                                  <fa-icon icon="download" class="primary-text" ></fa-icon>
                                  Edition pdf
                              </button>
                              <div class="dropdown-divider"></div>
                              <button (click)="modifierMouvement(historique)" ngbDropdownItem
                                      class="dropdown-item primary-text">
                                  <fa-icon icon="pencil-alt" class="primary-text"></fa-icon>
                                  Modifier
                              </button>
                              <button [disabled]="historique.estControle" (click)="supprimerMouvement(historique)" ngbDropdownItem
                                      class="dropdown-item primary-text">
                                  <fa-icon icon="trash-alt" class="primary-text"></fa-icon>
                                  Supprimer
                              </button>



                          </div>
                      </div>
                  </div>
              </td>
          </tr>
          </tbody>
      </table>
  </div>
</div>

<app-saisir-revendication
  [(visible)]="saisieDialogVisible"
  [lotRevendications]="saisieDialogLot"
  [indexModification]="saisieDialogIndex"
  (terminer)="onSaisieRevendicationTerminer($event)">
</app-saisir-revendication>

<app-synthese-saisie-revendication
  [(visible)]="syntheseDialogVisible"
  [lotRevendications]="syntheseLot"
  [creerRevendication]="creerRevendicationSynthese"
  (fermerModale)="onSyntheseRevendicationClose($event)">
</app-synthese-saisie-revendication>

<!-- Template aucun historique -->
<ng-template #aucunHistorique>
  <div class="alert alert-warning alert-block" translate>
    <fa-icon icon="exclamation"></fa-icon> page.declarations.suivi-declarations.aucunHistorique
  </div>
</ng-template>
<!-- Fin template aucun historique -->

